<app-processing [visible]="!pageVars.isReady"></app-processing>

<h3>Site Catalogs</h3>
<div class="flex flex-wrap align-items-center justify-content-start gap-2">
  <p-card *ngFor="let site of sites" class="function-card">
    <ng-template pTemplate="header">
      <div class="flex mt-1 ml-2">
        <h4 class="pl-1">{{ site.title }}</h4>
      </div>
    </ng-template>
    <p style="font-size: small; height: 5rem">
      {{ site.description }}
    </p>
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end">
        <p-button
          label="Go"
          [raised]="true"
          iconPos="right"
          size="small"
          icon="fa fa-angles-right"
          (click)="goClick(site.path)"
          attr.data-testid="go {{ site.title }}"></p-button>
      </div>
    </ng-template>
  </p-card>
</div>
